/**
 * Laravel JsonResource responses wrap the model in a top-level `data` object.
 * Some legacy endpoints may return the entity at the root.
 */
export function unwrapEntity(res) {
  if (!res || typeof res !== 'object') return null;
  const inner = res.data;
  if (inner && typeof inner === 'object' && !Array.isArray(inner)) {
    return inner;
  }
  return res;
}
